import { Component, EventEmitter, Input, Output } from '@angular/core';

export type SearchWidth = 'fill' | 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-search-input-new',
  template: `
    <div class="search-input" [ngClass]="'search-input--' + width">
      <app-icon class="search-input__icon" name="search" [size]="15" [strokeWidth]="2"></app-icon>
      <input class="search-input__field"
        type="text"
        [placeholder]="placeholder"
        [ngModel]="value"
        (ngModelChange)="valueChange.emit($event)">
    </div>
  `
})
export class SearchInputNewComponent {
  @Input() placeholder = 'Search...';
  @Input() width: SearchWidth = 'md';
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();
}
